import React from "react";
import { ContactSection, ScrollToTop, WhatWeDoSection } from "../../components";
import ServicesGrid from "../../components/ServicesGrid";
import { useOurServices } from "../../hooks/ourServicesHooks";
import { urlFor } from "../../lib/sanity";
import "../../styles.css";
import "./our-services.css";

const OurServices = () => {
  const { title, subtitle, description, loading, error } = useOurServices();

  if (loading) {
    return (
      <section className="heading">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="heading">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center py-5">
              <div className="alert alert-danger" role="alert">
                Error: {error}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="heading">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="mb-4 pt-5 mt-3">{title}</h1>
              <h2 className="mb-5">{subtitle}</h2>
              <p className="mb-0">{description}</p>
            </div>
          </div>
        </div>
      </section>

      <ServicesGrid />

      <WhatWeDoSection />

      <ContactSection />

      <ScrollToTop />
    </>
  );
};

export default OurServices;
